import React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { formatParagraphs, getPodcastImage } from '../../../models/Utils';
import { ADAARIARoles, ADAWidgitRoles, ADALandmarks } from '../../../models/ADA';
import PlayButton from '../../../assets/images/buttons/btn_play.svg';


import './AudioBase.scss';

const AudioBase = ({type, cardData, onPlay, controls }) => {
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const menuOpened = useSelector(state => state.data.menuOpened);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  var dividerClass = 'divider hidden';

  const podcastImage = getPodcastImage(cardData);

  return (

    <div className="video-slide">
      {podcastImage && podcastImage.Image ? (
        <div
          className="thumbnail"
          style={{ backgroundImage: `url("${mediaPath + podcastImage.Image}")` }}
          alt={podcastImage.AltText}
        >
          <div
            className="overlay"
            style={{
              backgroundColor: podcastImage.Overlay,
              opacity: podcastImage.Opacity,
              pointerEvents: 'all'
            }}
            onKeyPress={onPlay} onClick={onPlay}
            tabIndex={!menuOpened ? 0 : -1}
            role="button"
            aria-label="Play Video"
          >
            
          </div>
          
        </div>
        
      ) : (//no image found
        <>
          <div
            className="overlay"
            style={{
              backgroundColor: podcastImage.Overlay,
              opacity: podcastImage.Opacity,
            }}
          />
        </>
      )}
      <div style={{
              position: 'absolute',
              top: '45%',
              left: '50%',
              transform: 'translate(-50%,-50%)',
              pointerEvents: 'none',
              width: '10%',
              height: "10%",
        backgroundImage: `url("${PlayButton}")`,
        backgroundRepeat: 'no-repeat',
              backgroundPosition:'center'
            }} />
      {controls}
    </div>


    // <div className="text-holder">
    //   <div className="type">{type}</div>
    //   <div className="header"  tabIndex="0">{title}</div>
    //   <div className="ada-hidden">:</div>
    //   <div className="body">{formatParagraphs(subtitle)}</div>
    //   <div className="video-play-button"/>
    // </div>
  );
};

export default AudioBase;
